import useMutateApi from '@hooks/useMutateApi';
import type {PropsWithChildren} from 'react';
import {useRef} from 'react';

import {createBackgroundTasksStore} from './store';
import type {BackgroundTasksStoreApi, Task} from './types';
import {BackgroundTasksContext} from './useBackgroundTasks';

export const BackgroundTasksProvider = (props: PropsWithChildren) => {
  const {children} = props;
  const {trigger: subscribeApiService} = useMutateApi(`publicSubscribeToBackgroundTask`);
  // The generated names are positional, not semantic: `…Task1` is user_management_service and
  // `…Task2` is query_service, per the order their specs were added.
  const {trigger: subscribeUserManagementService} = useMutateApi(`publicSubscribeToBackgroundTask1`);
  const {trigger: subscribeQueryService} = useMutateApi(`publicSubscribeToBackgroundTask2`);

  const subscribe = async (taskId: string, target?: Task['subscribeTarget']) => {
    if (target === `query-service`) return subscribeQueryService({task_id: taskId});
    if (target === `user-management-service`) return subscribeUserManagementService({task_id: taskId});
    return subscribeApiService({task_id: taskId});
  };

  const storeRef = useRef<BackgroundTasksStoreApi>(createBackgroundTasksStore({subscribe}));

  return <BackgroundTasksContext.Provider value={storeRef.current}>{children}</BackgroundTasksContext.Provider>;
};
